import { render, staticRenderFns } from "./block-other-party-details.vue?vue&type=template&id=c8094b64&scoped=true&"
import script from "./block-other-party-details.vue?vue&type=script&lang=js&"
export * from "./block-other-party-details.vue?vue&type=script&lang=js&"
import style0 from "./block-other-party-details.vue?vue&type=style&index=0&id=c8094b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8094b64",
  null
  
)

export default component.exports